module.exports = __webpack_public_path__ + "static/media/veneto-3-01.4e8cdfa8.jpg";